// extracted by mini-css-extract-plugin
export var content = "_93-3";
export var list = "_93-4";
export var settingsContent = "_93-7";
export var settingsPanel = "_93-8";
export var state = "_93-6";
export var triggerBadge = "_93-2";
export var triggerButton = "_93-1";
export var triggerShell = "_93-0";
export var unreadDot = "_93-5";